import React from 'react';

import PageContainer from '../../components/pageContainer/PageContainer';
import { AccountTypeEnum } from '../../utils/enums';

import AdminHome from './adminHome/AdminHome';
import CertificateIssuerHome from './certificateIssuerHome/CertificateIssuerHome';
import CertificateReceiverHome from './certificateReceiverHome/CertificateReceiverHome';
import CorporateVerifierHome from './corporateVerifierHome/CorporateVerifierHome';
import LoggedOutHome from './loggedOutHome/LoggedOutHome';
import MiddleManHome from './middleManHome/MiddleManHome';
import NormalUserHome from './normalUserHome/NormalUserHome';

function Home() {
  const accountType = localStorage.getItem('accountType');

  const renderComponent = accType => {
    switch (accType) {
      case AccountTypeEnum.ADMIN:
        return <AdminHome/>;
      case AccountTypeEnum.CERTIFICATE_ISSUER:
        return <CertificateIssuerHome/>;
      case AccountTypeEnum.CERTIFICATE_RECEIVER:
        return <CertificateReceiverHome/>;
      case AccountTypeEnum.CORPORATE_VERIFIER:
        return <CorporateVerifierHome/>;
      case AccountTypeEnum.NORMAL_USER:
        return <NormalUserHome/>;
      case AccountTypeEnum.MIDDLE_MAN:
        return <MiddleManHome/>;
      default:
        return <LoggedOutHome/>;
    }
  };

  return (
    <PageContainer>
      { renderComponent(accountType) }
    </PageContainer>
  );
}

export default Home;
